module.exports = __webpack_public_path__ + "img/57.07d30725.png";